var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-card",
    { staticClass: "TextCard md-elevation-4" },
    [
      _c(
        "md-card-header",
        { staticClass: "TextCard__Wrapper" },
        [
          _c("md-card-header-text", { staticClass: "TextCard__Header" }, [
            _c(
              "div",
              { staticClass: "IconBox" },
              [
                _c(
                  "md-icon",
                  { staticClass: "IconBox__Icon" },
                  [_vm._t("textCard__Icon")],
                  2
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "md-title" }, [
              _c("h5", [_vm._t("textCard__Headline")], 2)
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "md-card-content",
        { staticClass: "TextCard__Content" },
        [_vm._t("textCard__Text")],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-13848f90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13848f90","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/company/kirc/components/TextCard.vue
// module id = null
// module chunks = 